<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div v-permissions="'user:query'" class="main" v-show="web == 'main'">
        <div class="title">员工中心</div>
        <el-form
          class="search-form"
          ref="form"
          :inline="true"
          :model="searchForm"
          label-width="80px"
          @submit.native.prevent="false"
        >
          <el-form-item label="姓名" class="name">
            <el-input
              size="small"
              v-model="searchForm.name"
              placeholder="请输入姓名"
              clearable
              @keyup.enter.native="search(1)"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="phone">
            <el-input
              size="small"
              v-model="searchForm.phone"
              placeholder="请输入手机号码"
              clearable
              @keyup.enter.native="search(1)"
            ></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button v-permissions="'user:query'" type="primary" size="small" class="search" @click="search"
              >查询
            </el-button>
            <el-button v-permissions="'user:add'" size="small" class="add" icon="el-icon-plus" @click="add"
              >新增用户
            </el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" height="74vh" style="width: 100%">
          <el-table-column label="账号">
            <template slot-scope="scope">
              <span>{{ scope.row.loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="入职时间">
            <template slot-scope="scope">
              <span>{{ scope.row.hiredate.substring(0, 10) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-show="scope.row.available === 1">在职</span>
              <span v-show="scope.row.available === 0">离职</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-permissions="'user:update'"
                size="mini"
                type="primary"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div class="page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 500, 1000, 2000]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="edit" v-show="web == 'edit' || web == 'add'">
        <div class="title">{{ web == 'edit' ? '编辑' : '新增' }}</div>
        <div class="el-form" label-position="top">
          <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules2">
            <el-row>
              <el-col :xs="24" :sm="12">
                <el-form-item label="账号" prop="workNumber">
                  <el-input
                    v-model="addForm.workNumber"
                    placeholder="请输入"
                    :disabled="web == 'edit'"
                    @blur="checkUniqueWorkNumber('check')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item label="手机" prop="phone">
                  <el-input v-model="addForm.phone" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item label="角色" prop="role">
                  <el-select v-model="addForm.role" placeholder="请选择">
                    <el-option :label="item.name" :value="item.id" v-for="item in menus" :key="item.roleId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item label="内容权限" prop="content_jurisdiction">
                  <el-radio-group v-model="addForm.content_jurisdiction">
                    <el-radio label="0">只能看自己的</el-radio>
                    <el-radio label="1">能看全公司的</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item label="入职时间" prop="hiredate">
                  <el-date-picker
                    v-model="addForm.hiredate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item class="btn">
              <span v-show="!addForm.id">
                <el-button
                  v-permissions="'user:add'"
                  type="primary"
                  size="small"
                  class="save"
                  @click="checkUniqueWorkNumber('addForm')"
                  >保存
                </el-button>
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;

              <span v-show="addForm.id">
                <el-button
                  v-permissions="'user:update'"
                  type="primary"
                  size="small"
                  class="save"
                  @click="editSave('addForm')"
                  >保存
                </el-button>
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span v-show="addForm.id">
                <el-button v-permissions="'user:resetPwd'" size="small" plain type="warning" @click="resetPwd()"
                  >重置密码</el-button
                >
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span v-show="addForm.id">
                <el-button v-permissions="'user:resign'" size="small" plain type="danger" @click="handleDelete()"
                  >注销</el-button
                >
              </span>
              <el-button v-permissions="'user:query'" type="primary" size="small" plain class="cancel" @click="cancel"
                >返回列表</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div
          v-show="
            web == 'edit' &&
              userInfo.id !== addForm.id &&
              (userInfo.permissions.indexOf('user:handoverCustomer') > 0 ||
                userInfo.permissions.indexOf('user:handoverCase') > 0)
          "
        >
          <div class="title">交接</div>
          <div class="el-form" label-position="top">
            <el-form ref="form2" :model="addForm" label-width="100px" :rules="rules">
              <el-row>
                <el-col :xs="24" :sm="12">
                  <el-form-item label="接手员工" prop="role">
                    <el-select v-model="addForm.uid2" placeholder="请选择">
                      <el-option
                        :disabled="item.id === addForm.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in persons"
                        :key="item.roleId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item class="btn">
                <span v-show="addForm.id">
                  <el-button
                    v-permissions="'user:handoverCustomer'"
                    type="danger"
                    size="small"
                    class="save"
                    @click="handoverCustomer"
                    >交接客户
                  </el-button>
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span v-show="addForm.id">
                  <el-button
                    v-permissions="'user:handoverCase'"
                    type="danger"
                    size="small"
                    class="save"
                    @click="handoverCase"
                    >交接案件
                  </el-button>
                </span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'User',
  data() {
    return {
      userInfo: {},
      titles: ['员工中心'],
      web: 'main',
      searchForm: {
        name: '',
        phone: ''
      },
      addForm: {
        id: '',
        uid2: '',
        hiredate: '',
        name: '',
        phone: '',
        role: '',
        workNumber: '',
        qx: [],
        content_jurisdiction: '',
        contentJurisdiction: ''
      },
      persons: [],
      menus: [],
      tableData: [],
      currentPage: 1,
      pageSize: 100,
      total: 400,
      rules: {
        workNumber: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        content_jurisdiction: [{ required: true, message: '请选择内容权限', trigger: 'change' }],
        phone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(rule.msg)
              } else {
                const reg = /^[1][3-9][0-9]{9}$/
                reg.test(value) ? callback() : callback('请输入正确的手机号码')
              }
            },
            msg: '请输入手机号码',
            trigger: 'blur'
          }
        ]
      },
      rules2: {
        role: [{ required: true, message: '请选择权限', trigger: 'change' }]
      }
    }
  },
  methods: {
    titleClick(item, index) {
      console.log(item, index)
      if (item === '员工中心') {
        this.web = 'main'
        this.titles = ['员工中心'] // 导航菜单
      }
    },
    search() {
      // 查询
      this.queryUserList()
    },
    reset() {
      // 重置
      this.searchForm = {
        name: '',
        phone: ''
      }
    },
    add() {
      this.web = 'add'
      this.titles = ['员工中心', '新增']
      setTimeout(() => {
        this.$refs.addForm.clearValidate()
      }, 0)
    }, // 新增
    handleEdit(index, row) {
      // 编辑
      console.log(index, row)
      this.web = 'edit'
      this.titles = ['员工中心', '编辑']
      for (const i in row) {
        this.addForm[i] = row[i]
      }
      this.addForm.content_jurisdiction = row.contentJurisdiction
      this.addForm.contentJurisdiction = row.contentJurisdiction
      this.addForm.hiredate = this.$common.timeFormat(new Date(row.hiredate.replace(/\-/g, '/')), 'yyyy-MM-dd')
      this.addForm = JSON.parse(JSON.stringify(this.addForm))
      this.$refs.addForm.clearValidate()
      this.queryUserRole()
    },
    queryUserRole() {
      const param = {
        id: this.addForm.id
      }
      this.$get('/user/queryUserRole', param).then(
        result => {
          if (result.status === 200) {
            this.addForm.role = result.data || ''
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    handleDelete() {
      // 删除
      this.$root.$children[0].vueConfirm(
        { message: '确认要注销此用户吗?' },
        () => {
          const param = {
            id: this.addForm.id,
            cid: this.addForm.cid
          }
          this.$get('/user/resign', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消注销')
        }
      )
    },
    resetPwd() {
      // 删除
      this.$root.$children[0].vueConfirm(
        { message: '确认要重置此用户密码吗?' },
        () => {
          const param = {
            id: this.addForm.id,
            cid: this.addForm.cid
          }
          this.$get('/user/resetPwd', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消重置密码')
        }
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.search()
    },
    // 检查工号是否重复
    checkUniqueWorkNumber(name) {
      if (name === 'check') {
        const param = {
          workNumber: this.addForm.workNumber
        }
        this.$get('/user/checkUniqueWorkNumber', param).then(
          result => {
            if (result.status === 200) {
              // this.addSave(name)
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.$refs[name].validate(valid => {
          if (valid) {
            console.log('通过')
            const param = {
              workNumber: this.addForm.workNumber
            }
            this.$get('/user/checkUniqueWorkNumber', param).then(
              result => {
                if (result.status === 200) {
                  this.addSave(name)
                } else {
                  this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
                }
              },
              error => {
                this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
              }
            )
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    // 新增提交
    addSave() {
      const param = {
        workNumber: this.addForm.workNumber,
        name: this.addForm.name,
        phone: this.addForm.phone,
        hiredate: this.addForm.hiredate,
        role: this.addForm.role,
        content_jurisdiction: this.addForm.content_jurisdiction
      }
      this.$post('/user/addUser', param).then(
        result => {
          if (result.status === 200) {
            // this.web = 'main'
            // this.titles = ['员工中心']
            this.handleEdit('add', result.data)
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            // this.search()
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 编辑提交
    editSave(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            id: this.addForm.id,
            workNumber: this.addForm.workNumber,
            name: this.addForm.name,
            phone: this.addForm.phone,
            hiredate: this.addForm.hiredate,
            role: this.addForm.role,
            content_jurisdiction: this.addForm.content_jurisdiction
          }
          this.$post('/user/update', param).then(
            result => {
              if (result.status === 200) {
                // this.web = 'main'
                // this.titles = ['员工中心']
                this.handleEdit('add', result.data)
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                // this.search()
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 返回取消
    cancel() {
      this.addForm = {
        id: '',
        uid2: '',
        hiredate: '',
        name: '',
        phone: '',
        role: '',
        workNumber: '',
        qx: [],
        content_jurisdiction: '',
        contentJurisdiction: ''
      }
      this.web = 'main'
      this.titles = ['员工中心']
      this.queryUserList()
    },
    // 查询用户列表
    queryUserList() {
      // 查询用户列表
      const param = {
        name: this.searchForm.name,
        phone: this.searchForm.phone,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.$post('/user/query', param).then(
        result => {
          // console.log(result)
          if (result.status === 200) {
            this.total = result.count
            this.tableData = result.data
            // localStorage.setItem('collectedPerson', JSON.stringify({ imgUrl: 'imageBase64' }))
            console.log('调通了')
          } else {
            console.log('失败 提示语句')
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.message, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询所有角色
    queryAllRole() {
      // 查询用户列表
      const param = {
        page: 1,
        limit: 1000
      }
      this.$post('/role/queryAllRole', param).then(
        result => {
          if (result.status === 200) {
            this.menus = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          console.log('没调通', error)
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 交接客户
    handoverCustomer() {
      if (!this.addForm.uid2) {
        return this.$root.$children[0].vueAlert({ message: '请选择接手员工！', type: 'error' })
      }
      this.$root.$children[0].vueConfirm(
        { message: '确认要交接客户吗?' },
        () => {
          const param = {
            uid1: this.addForm.id, // 离职员工id
            uid2: this.addForm.uid2 // 接手员工id
          }
          this.$get('/customer/handoverCustomer', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消交接')
        }
      )
    },
    // 交接案件
    handoverCase() {
      if (!this.addForm.uid2) {
        return this.$root.$children[0].vueAlert({ message: '请选择接手员工！', type: 'error' })
      }
      this.$root.$children[0].vueConfirm(
        { message: '确认要交接案件吗?' },
        () => {
          const param = {
            uid1: this.addForm.id, // 离职员工id
            uid2: this.addForm.uid2 // 接手员工id
          }
          this.$get('/case/handoverCase', param).then(
            result => {
              if (result.status === 200) {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消交接')
        }
      )
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    } else {
      return this.$root.$children[0].vueAlert({ message: '未获取到用户信息', type: 'warning' })
    }
    this.queryUserList()
    this.queryAllRole()
    this.queryUserIdName()
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped></style>
